import { AuthenticatedGuard } from "@/components/authenticated-guard";
import Header from "@/components/header.tsx";
import { OmtAmsOperatorImpersonationGate } from "@/components/omt-ams/operator-impersonation-gate";
import { OmtAmsPendingInviteCheck } from "@/components/omt-ams/pending-invite-check";
import { EmailVerificationCheck } from "@/components/registrant/email-verification-check";
import { UserType } from "@/constants";
import { useLicenseChangeEvents } from "@/hooks/use-license-change-events";
import { getOmtAmsLoginConnection } from "@/lib/omt-ams-login-connection";
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import Auth0Provider from "../integrations/auth0/root-provider.tsx";

function OmtAmsLayout() {
  const { user } = useAuth0();
  useLicenseChangeEvents();

  return (
    <div className="flex h-dvh flex-col overflow-hidden">
      <Header
        user={user || null}
        showOmtAmsOperatorImpersonation
        showOmtAmsHelp
      />
      <main className="flex flex-1 min-h-0 w-full justify-center overflow-hidden p-4 md:p-6 max-w-[1600px] mx-auto bg-background">
        <AuthenticatedGuard
          allowedUserTypes={[UserType.OMT_AMS, UserType.OPERATOR]}
          loginConnection={getOmtAmsLoginConnection()}
        >
          <OmtAmsOperatorImpersonationGate>
            <EmailVerificationCheck>
              <OmtAmsPendingInviteCheck>
                <div
                  data-slot="portal-page-scroll"
                  className="flex flex-1 min-h-0 w-full min-w-0 flex-col overflow-y-auto"
                >
                  <Outlet />
                </div>
              </OmtAmsPendingInviteCheck>
            </EmailVerificationCheck>
          </OmtAmsOperatorImpersonationGate>
        </AuthenticatedGuard>
      </main>
    </div>
  );
}

export const Route = createFileRoute("/omt-ams")({
  component: () => (
    <Auth0Provider
      audience={import.meta.env.VITE_AUTH0_OMT_AMS_AUDIENCE}
      clientId={import.meta.env.VITE_AUTH0_OMT_AMS_CLIENT_ID}
      callbackPath="/omt-ams/auth_callback"
    >
      <OmtAmsLayout />
    </Auth0Provider>
  ),
});
